import Axios from './caller.service'

let login = (email, password) => {
    return Axios.post('api/login', email, password)
}

const LogOut = async () => {
    try {
        const token = localStorage.getItem('token');
        await Axios.post('api/logout', null, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        localStorage.removeItem('token');

    } catch (error) {
        console.error("Erreur lors de la déconnexion:", error);
        throw error;
    }
};


let getToken = () => {
    return localStorage.getItem('token')
}

let saveToken = (token) => {
    localStorage.setItem('token', token)
}

let isLogged = () => {
    let token = localStorage.getItem('token')
    // transformer une chaine en booléen
    return token
}


export const accountService = {
    login,
    LogOut,
    saveToken,
    getToken,
    isLogged
}